var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// helpers
import { setCommonFields } from './helpers/commonFields';
import { validateEventForPageLoad, getEventDataForPageLoad, getExistingDataLayerEvents } from './helpers/dataLayer';
import { initializeBatch, destroyBatch, batchEvent, batchMultipleEvents, batchImpressionEvents, sendBeaconEvent, filterMultipleEventList, convertArrayToObject, addAdditionalDetailsToEvent, } from './helpers/events';
// constants
import { DEFAULT_EVENT_THRESHOLD, } from './constants';
class AnalyticsSDK {
    constructor(_a) {
        var { analyticsEndpoint, batchInterval = 20000, analyticsSDKVersion = '', excludedEventNames = [], eventsThreshold = DEFAULT_EVENT_THRESHOLD } = _a, rest = __rest(_a, ["analyticsEndpoint", "batchInterval", "analyticsSDKVersion", "excludedEventNames", "eventsThreshold"]);
        this.version = '';
        this.excludedEventsMap = {};
        this.initializeDataLayer = () => {
            const eventsToPushInRetina = getExistingDataLayerEvents();
            eventsToPushInRetina.map((event) => {
                if (event) {
                    this.sendEvent(event.eventName, event.data);
                }
                return true;
            });
        };
        /**
         * Destroy all event listeners
         */
        this.destroy = () => {
            destroyBatch();
        };
        /**
         * Set Analytics common fields
         * @param {object} fields - common fields service would like to override or set
         */
        this.setCommonFields = setCommonFields;
        /**
         * Send analytics event
         * @param {string} eventName - event name
         * @param {object} data - event data
         */
        this.sendEvent = (eventName, data) => {
            if (this.excludedEventsMap[eventName])
                return;
            const timestamp = new Date().getTime() / 1000;
            const eventData = Object.assign({ hit_recorded_at: timestamp }, addAdditionalDetailsToEvent(Object.assign(Object.assign({}, data), { event_name: eventName })));
            // attempt sending event using sendBeacon
            if (sendBeaconEvent([eventData])) {
                return;
            }
            batchEvent(eventData);
        };
        /**
         * Send multiple analytics event
         * @param {object[]} data - event data
         */
        this.sendMultipleEvents = (multipleEvents) => {
            // Exclude events which are whitelisted
            const filteredEventList = filterMultipleEventList(multipleEvents, this.excludedEventsMap) || [];
            // return if filteredEventList is empty, that means multipleEvents is blacklisted in the config
            if (filteredEventList && filteredEventList.length === 0)
                return;
            const timestamp = new Date().getTime() / 1000;
            const eventData = filteredEventList.map((event) => (Object.assign({ hit_recorded_at: timestamp }, addAdditionalDetailsToEvent(event))));
            // attempt sending event using sendBeacon
            if (sendBeaconEvent(eventData)) {
                return;
            }
            batchMultipleEvents(eventData);
        };
        /**
         * Send impression event
         * @param {string} eventName - event name
         * @param {object[]} data - impression event data
         */
        this.sendImpressionEvent = (eventName, impressionData) => {
            if (this.excludedEventsMap[eventName])
                return;
            batchImpressionEvents(Object.assign(Object.assign({ event_name: eventName }, impressionData), addAdditionalDetailsToEvent(impressionData)));
        };
        /**
         * Push dataLayer event in Retina pipeline
         * @param {object} data - dataLayer event
         */
        this.pushDataLayerEvent = (data) => {
            const shouldPushEventInRetina = validateEventForPageLoad(data);
            if (shouldPushEventInRetina) {
                const eventToPush = getEventDataForPageLoad(data);
                if (eventToPush) {
                    this.sendEvent(eventToPush.eventName, eventToPush.data);
                }
            }
        };
        this.version = analyticsSDKVersion;
        this.excludedEventsMap = convertArrayToObject(excludedEventNames);
        setCommonFields(Object.assign({ sdkVersion: analyticsSDKVersion }, rest));
        initializeBatch(analyticsEndpoint, batchInterval, eventsThreshold);
        this.initializeDataLayer();
    }
}
export default AnalyticsSDK;
